import Filter from "./Filter";

class SearchFilter extends Filter {
  constructor(el){
    super(el);
  }
}

export default SearchFilter;